import { createSvgIcon } from '@mui/material/utils';

const MetricLevel = createSvgIcon(
  <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M25.3047 1.30469V20.5047M25.3047 1.30469L15.7047 10.9047M25.3047 1.30469L34.9047 10.9047M1.30469 32.5047C2.74469 33.7047 4.18469 34.9047 7.30469 34.9047C13.3047 34.9047 13.3047 30.1047 19.3047 30.1047C25.5447 30.1047 25.0647 34.9047 31.3047 34.9047C37.3047 34.9047 37.3047 30.1047 43.3047 30.1047C46.4247 30.1047 47.8647 31.3047 49.3047 32.5047M1.30469 46.9047C2.74469 48.1047 4.18469 49.3047 7.30469 49.3047C13.3047 49.3047 13.3047 44.5047 19.3047 44.5047C25.5447 44.5047 25.0647 49.3047 31.3047 49.3047C37.3047 49.3047 37.3047 44.5047 43.3047 44.5047C46.4247 44.5047 47.8647 45.7047 49.3047 46.9047" stroke="white" strokeWidth="2.61" strokeLinecap="round" strokeLinejoin="round"/>
</svg>,
  'MetricLevel',
);

export default MetricLevel;
